module.exports = __webpack_public_path__ + "static/image-1f257e0dfae48fce4b3fbac9bf80e255.jpg";